// src/pages/ChapterTen.js
// Chapter 10 — Final Battle: Für Elise (Ancient Melody)
// Story: Doron awakens for the final battle. Playing the ancient melody (a Für Elise
// excerpt) channels Treblin’s power. Finish it cleanly to turn Doron into stone.

import React from "react";
import ChapterTemplate from "../components/ChapterTemplate";

// 🎵 Für Elise — simplified excerpt using your sequence (octaves kept for clarity)
// Notes you provided:
// 1) E5 D#5 E5 D#5 E5 B4 D4 C5 A4
// 2) C4 E4 A4 B4
// 3) E  G#  A  B
// 4) E5 D#5 E5 D#5 E5 B4 D4 C5 A4
// 5) C4 E4 A4 B4
// 6) E  C5  B  A4
//
// Spacers "__" are just for nicer grouping on screen; matching ignores them.

const furEliseLines = [
  ["E5", "D#5", "E5", "D#5", "E5", "B4", "D5", "C5", "A4"],
  ["C4", "E4", "A4", "B4"],
  ["E", "G#", "B4", "C5"],
  ["E5", "D#5", "E5", "D#5", "E5", "B4", "D5", "C5", "A4"],
  ["C4", "E4", "A4", "B4"],
  ["E", "C5", "B4", "A4"],
];

const furEliseMelody = furEliseLines.flat();

// 🖼️ Story slides (placeholders; swap art later)
const ChapterTenStory = [
  {
    image: "/images/ChapterTen/Ch10 Slide 1.png",
    text: "Storm clouds gather over Treble Peak. Doron awakens, wings casting a shadow across the valley.",
  },
  {
    image: "/images/ChapterTen/Chp 10 Slide 2.png",
   // text: "Giz traces the constellation—“This is the ancient melody. Play it true and channel Treblin’s light.”",
  },
 
  {
    image: "/images/ChapterTen/Ch10 Melody.png",
    text: "Begin the battle. And defeat Doron",
    melody: true,
  },
 
];

export default function ChapterTen() {
  return (
    <ChapterTemplate
      chapterNumber={10}
      chapterTitle="Final Battle — Für Elise (Ancient Melody)"
      sceneImageSrc="/images/ChapterTen/Ch10 Melody.png"
      storySlides={ChapterTenStory}
      targetMelody={furEliseMelody}
      melodyLines={furEliseLines}
      songTitle="Für Elise — Final Battle Excerpt"
      companionsText={{
        wis:
          "Count in fours and keep your touch light on E5 and D#5. Precision wins this battle.",
        pan:
          "We’ve got this! When you feel the leap to C5, trust your fingers and keep going! 💫",
      }}
      // Doron must start AWAKE in Chapter 10; he “falls” (stone/sleep) on completion.
      doronAwakeInitially={true}
      // After the finale, send players to the constellation page as an epilogue.
      unlockNextChapterPath="/constellation"
    />
  );
}
